// adapted from https://github.com/on-the-edge-cloud/react-circle-flags/blob/master/src/index.js
// available from https://hatscripts.github.io/circle-flags/gallery

export const territories: Record<string, boolean> = {
  ac: true,
  ad: true,
  ae: true,
  af: true,
  afar: true,
  ag: true,
  ai: true,
  al: true,
  am: true,
  an: true,
  ao: true,
  aq: true,
  ar: true,
  as: true,
  at: true,
  au: true,
  'au-aboriginal': true,
  'au-act': true,
  'au-nsw': true,
  'au-nt': true,
  'au-qld': true,
  'au-tas': true,
  'au-vic': true,
  'au-wa': true,
  aw: true,
  ax: true,
  az: true,
  ba: true,
  bb: true,
  bd: true,
  be: true,
  bf: true,
  bg: true,
  bh: true,
  bi: true,
  bj: true,
  bl: true,
  bm: true,
  bn: true,
  bo: true,
  'bq-bo': true,
  'bq-sa': true,
  'bq-se': true,
  bq: true,
  br: true,
  bs: true,
  bt: true,
  bv: true,
  bw: true,
  by: true,
  bz: true,
  'ca-bc': true,
  'ca-qc': true,
  ca: true,
  cc: true,
  cd: true,
  cf: true,
  cg: true,
  'ch-gr': true,
  ch: true,
  ci: true,
  ck: true,
  cl: true,
  cm: true,
  'cn-xj': true,
  cn: true,
  co: true,
  cp: true,
  cq: true,
  cr: true,
  cu: true,
  cv: true,
  cw: true,
  cx: true,
  cy: true,
  cz: true,
  de: true,
  dg: true,
  dj: true,
  dk: true,
  dm: true,
  do: true,
  dz: true,
  ea: true,
  earth: true,
  east_african_federation: true,
  easter_island: true,
  'ec-w': true,
  ec: true,
  ee: true,
  eg: true,
  eh: true,
  er: true,
  'es-ar': true,
  'es-ce': true,
  'es-cn': true,
  'es-ct': true,
  'es-ga': true,
  'es-ib': true,
  'es-ml': true,
  'es-pv': true,
  'es-variant': true,
  es: true,
  'et-or': true,
  'et-ti': true,
  et: true,
  eu: true,
  european_union: true,
  ewe: true,
  fi: true,
  fj: true,
  fk: true,
  fm: true,
  fo: true,
  'fr-20r': true,
  'fr-bre': true,
  'fr-cp': true,
  fr: true,
  fx: true,
  ga: true,
  'gb-con': true,
  'gb-eng': true,
  'gb-nir': true,
  'gb-ork': true,
  'gb-sct': true,
  'gb-wls': true,
  gb: true,
  gd: true,
  'ge-ab': true,
  ge: true,
  gf: true,
  gg: true,
  gh: true,
  gi: true,
  gl: true,
  gm: true,
  gn: true,
  gp: true,
  gq: true,
  gr: true,
  gs: true,
  gt: true,
  gu: true,
  guarani: true,
  gw: true,
  gy: true,
  hausa: true,
  hk: true,
  hm: true,
  hmong: true,
  hn: true,
  hr: true,
  ht: true,
  hu: true,
  ic: true,
  id: true,
  'id-jb': true,
  'id-jt': true,
  ie: true,
  il: true,
  im: true,
  'in-as': true,
  'in-gj': true,
  'in-ka': true,
  'in-or': true,
  'in-tn': true,
  in: true,
  io: true,
  iq: true,
  ir: true,
  is: true,
  'it-23': true,
  'it-82': true,
  'it-88': true,
  it: true,
  je: true,
  jm: true,
  jo: true,
  jp: true,
  kanuri: true,
  ke: true,
  kg: true,
  kh: true,
  ki: true,
  kikuyu: true,
  km: true,
  kn: true,
  kongo: true,
  kp: true,
  kr: true,
  kurdistan: true,
  kw: true,
  ky: true,
  kz: true,
  la: true,
  lb: true,
  lc: true,
  li: true,
  lk: true,
  lr: true,
  ls: true,
  lt: true,
  lu: true,
  lv: true,
  ly: true,
  ma: true,
  malayali: true,
  manipur: true,
  maori: true,
  mc: true,
  md: true,
  me: true,
  mf: true,
  mg: true,
  mh: true,
  mizoram: true,
  mk: true,
  ml: true,
  mm: true,
  mn: true,
  mo: true,
  mp: true,
  mq: true,
  mr: true,
  ms: true,
  mt: true,
  mu: true,
  mv: true,
  mw: true,
  mx: true,
  my: true,
  mz: true,
  na: true,
  nato: true,
  nc: true,
  ne: true,
  nf: true,
  ng: true,
  ni: true,
  'nl-fr': true,
  nl: true,
  no: true,
  northern_cyprus: true,
  np: true,
  nr: true,
  nu: true,
  nz: true,
  occitania: true,
  olympics: true,
  om: true,
  otomi: true,
  pa: true,
  pe: true,
  pf: true,
  pg: true,
  ph: true,
  'pk-jk': true,
  'pk-sd': true,
  pk: true,
  pl: true,
  pm: true,
  pn: true,
  pr: true,
  ps: true,
  'pt-20': true,
  'pt-30': true,
  pt: true,
  pw: true,
  py: true,
  qa: true,
  quechua: true,
  re: true,
  ro: true,
  rs: true,
  ru: true,
  'ru-ba': true,
  'ru-ce': true,
  'ru-cu': true,
  'ru-da': true,
  'ru-ko': true,
  'ru-ta': true,
  'ru-ud': true,
  rw: true,
  sa: true,
  sami: true,
  sb: true,
  sc: true,
  sd: true,
  se: true,
  sg: true,
  'sh-ac': true,
  'sh-hl': true,
  'sh-ta': true,
  sh: true,
  si: true,
  sj: true,
  sk: true,
  sl: true,
  sm: true,
  sn: true,
  so: true,
  somaliland: true,
  south_ossetia: true,
  soviet_union: true,
  sr: true,
  ss: true,
  st: true,
  su: true,
  sv: true,
  sx: true,
  sy: true,
  sz: true,
  ta: true,
  tc: true,
  td: true,
  tf: true,
  tg: true,
  th: true,
  tibet: true,
  tj: true,
  tk: true,
  tl: true,
  tm: true,
  tn: true,
  to: true,
  torres_strait_islands: true,
  tr: true,
  transnistria: true,
  tt: true,
  tv: true,
  tw: true,
  tz: true,
  ua: true,
  ug: true,
  uk: true,
  um: true,
  un: true,
  united_nations: true,
  'us-al': true,
  'us-ak': true,
  'us-az': true,
  'us-ar': true,
  'us-ca': true,
  'us-co': true,
  'us-fl': true,
  'us-ga': true,
  'us-hi': true,
  'us-in': true,
  'us-md': true,
  'us-ms': true,
  'us-mo': true,
  'us-nm': true,
  'us-or': true,
  'us-ri': true,
  'us-sc': true,
  'us-tn': true,
  'us-tx': true,
  'us-wa': true,
  'us-wi': true,
  'us-wy': true,
  'us-dc': true,
  'us-as': true,
  'us-gu': true,
  'us-mp': true,
  'us-pr': true,
  'us-um': true,
  'us-vi': true,
  us: true,
  uy: true,
  uz: true,
  va: true,
  vc: true,
  ve: true,
  vg: true,
  vi: true,
  vn: true,
  vu: true,
  wf: true,
  wiphala: true,
  ws: true,
  xk: true,
  xx: true,
  ye: true,
  yorubaland: true,
  yt: true,
  za: true,
  zm: true,
  zw: true
}
